// For documentation purposes.
export { iconMeta } from "./iconMeta";

export { Icon } from "./components/icon/Icon";
export type { IconProps } from "./components/icon/Icon";

export * from "./generated";
export * from "./components/custom";
